import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ItemResponse, ListResponse, PasskeyListItem, PasskeyRegisterOptionsResponse } from '@proerp/shared';
import { apiRequest } from '@/lib/apiClient';

/** Self-Service-Verwaltung eigener Passkeys (ADR 0034) — genutzt von `SecuritySettingsDialog`. */

const PASSKEYS_KEY = ['auth', 'passkeys'] as const;

export function usePasskeys() {
  return useQuery({
    queryKey: PASSKEYS_KEY,
    queryFn: () => apiRequest<ListResponse<PasskeyListItem>>('/v1/auth/passkey'),
  });
}

export function useRegisterPasskeyOptions() {
  return useMutation({
    mutationFn: () =>
      apiRequest<ItemResponse<PasskeyRegisterOptionsResponse>>('/v1/auth/passkey/register-options', {
        method: 'POST',
      }),
  });
}

export function useRegisterPasskey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { challengeToken: string; attestationResponse: unknown; deviceLabel: string }) =>
      apiRequest<void>('/v1/auth/passkey/register', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PASSKEYS_KEY }),
  });
}

export function useDeletePasskey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiRequest<void>(`/v1/auth/passkey/${id}`, { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PASSKEYS_KEY }),
  });
}
